/* 一覧の商品画像：2枚目は、スマホで指を置いたとき／パソコンでカーソルを合わせたときに初めて読み込む */
(function () {
  if (window.__cardSwipeInit) return;
  window.__cardSwipeInit = true;

  function load(card) {
    if (!card) return;
    var media = card.querySelector('.card-swipe');
    if (!media || media.getAttribute('data-loaded')) return;
    media.setAttribute('data-loaded', '1');
    var img = media.querySelector('img[data-srcset]');
    if (!img) return;
    var done = function () { media.classList.add('second-ready'); };
    img.addEventListener('load', done, { once: true });
    img.srcset = img.getAttribute('data-srcset');
    img.src = img.getAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
  }

  function handler(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    load(t.closest('.card-wrapper'));
  }

  document.addEventListener('touchstart', handler, { passive: true });
  document.addEventListener('pointerover', handler, { passive: true });
  document.addEventListener('focusin', handler);
})();
